import { render } from "./VideosList.vue?vue&type=template&id=a75d34f6&ts=true"
import script from "./VideosList.vue?vue&type=script&lang=ts"
export * from "./VideosList.vue?vue&type=script&lang=ts"

import "./VideosList.vue?vue&type=style&index=0&id=a75d34f6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__